import React, { useEffect, useState } from "react";
import axios from "axios";
import "./History.css";
import SearchBar from "../../Component/SearchBar/SerachBar";
import { Api } from "../../../Admin/BackendApi/api";
import { useNavigate } from "react-router-dom";
import { FaSortAmountDown } from "react-icons/fa";
import SortModal from "../../Component/SortModal/SortModal";
import { APP_VERSION } from "../../../Admin/Pages/Version Provider/VersionConfig";
import ConfirmPopup from "../../../Admin/Component/ConfirmPopup/ConfirmPopup";

const History = () => {
    const [search, setSearch] = useState("");
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [sortColumn, setSortColumn] = useState("TransValue");
    const [sortOrder, setSortOrder] = useState(-1);
    const [isSortOpen, setIsSortOpen] = useState(false);

    const [versionCode] = useState(APP_VERSION);

    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "error",
    });

    const navigate = useNavigate();

    const handlePopupClose = () => {
        setPopup({ ...popup, show: false });
    };

    const fetchTransactions = async (searchValue = "") => {
        try {
            setLoading(true);

            const token = localStorage.getItem("token");

            if (!token) {
                navigate("/user/login");
                return;
            }

            let finalSearch = searchValue.trim().toLowerCase();

            if (finalSearch.includes("allo")) {
                finalSearch = "IN";
            } else if (finalSearch.includes("ded")) {
                finalSearch = "OUT";
            }

            const response = await axios.post(
                Api.getTransaction,
                {
                    VersionCode: versionCode,
                    searchstring: finalSearch,
                    sort_column: sortColumn,
                    sort_order: sortOrder,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.status === 0) {

                setPopup({
                    show: true,
                    message: (
                        <>
                            <span style={{ fontSize: "20px" }}>❌</span>{" "}
                            {response.data.message}
                        </>
                    ),
                    type: "error",
                });

                return;
            }

            if (response.data.status === 1) {
                setTransactions(
                    Array.isArray(response.data.data) ? response.data.data : []
                );
            } else {
                setTransactions([]);
            }

        } catch (error) {

            console.error("Error fetching transactions:", error);

            setPopup({
                show: true,
                message: "Server error. Try again.",
                type: "error",
            });

        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            fetchTransactions(search);
        }, 300);

        return () => clearTimeout(delayDebounce);
    }, [search, sortColumn, sortOrder]);

    const totalCoins = transactions.reduce((sum, tx) => {
        const value = Number(tx.TransValue || 0);

        if (tx.TransType?.toUpperCase() === "IN") {
            return sum + value;
        } else {
            return sum - value;
        }
    }, 0);

    return (
        <div className="user-history-container">

            <div
                className="user-product-header"
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px",
                }}
            >
                <SearchBar
                    search={search}
                    setSearch={setSearch}
                    onSearchClick={() => fetchTransactions(search)}
                />

                <div
                    onClick={() => setIsSortOpen(true)}
                    style={{
                        backgroundColor: "#704A94",
                        padding: "8px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        marginBottom: "10px",
                    }}
                >
                    <FaSortAmountDown color="white" />
                </div>
            </div>

            <SortModal
                isOpen={isSortOpen}
                onClose={() => setIsSortOpen(false)}
                onApply={(col, order) => {
                    setSortColumn(col);
                    setSortOrder(order === "asc" ? 1 : -1);
                }}
                currentColumn={sortColumn}
                currentOrder={sortOrder === 1 ? "asc" : "desc"}
                columns={[
                    { label: "TransType", value: "TransType" },
                    { label: "Amount", value: "TransValue" },
                    { label: "Remarks", value: "TransDesc" },
                    { label: "Date", value: "TransDate" },
                ]}
            />

            <div className="user-balance-card">
                <div className="user-history-header">
                    <h2 className="user-history-title">Total Balance</h2>
                    <p className={`user-history-coins ${totalCoins >= 0 ? "user-positive" : "user-negative"}`}>
                        {totalCoins >= 0 ? `+${totalCoins}` : totalCoins}
                    </p>
                </div>
            </div>

            <div className="user-transactions-scroll">
                <div className="user-transactions-list">

                    {loading ? (
                        <div className="spinner-container">
                            <div className="spinner"></div>
                        </div>
                    ) : transactions.length === 0 ? (
                        <p>No transactions found</p>
                    ) : (
                        transactions.map((tx, index) => (
                            <div className="user-transaction-card" key={index}>

                                <div className="user-transaction-header">

                                    <div>
                                        <p className="user-transaction-id">
                                            Transaction No: {tx.TransNo}
                                        </p>

                                        <p className="user-transaction-desc">
                                            {tx.TransDesc}
                                        </p>

                                        <p className="user-transaction-billinfo">
                                            <span style={{ fontWeight: "bold" }}>
                                                Billinfo :
                                            </span>{" "}
                                            {tx.BillInfo}
                                        </p>
                                    </div>

                                    <p
                                        className={`user-transaction-amount ${
                                            tx.TransType?.toUpperCase() === "IN"
                                                ? "user-amount-alloted"
                                                : "user-amount-deducted"
                                        }`}
                                    >
                                        {tx.TransType?.toUpperCase() === "IN"
                                            ? `+${Math.abs(tx.TransValue)}`
                                            : `-${Math.abs(tx.TransValue)}`}
                                    </p>

                                </div>

                                <div className="user-transaction-footer">

                                    <p
                                        className={`user-transaction-status ${
                                            tx.TransType?.toUpperCase() === "IN"
                                                ? "user-alloted"
                                                : "user-deducted"
                                        }`}
                                    >
                                        {tx.TransType?.toUpperCase() === "IN"
                                            ? "Alloted"
                                            : "Deducted"}
                                    </p>

                                </div>

                                <div className="user-transaction-date">
                                    {new Date(tx.TransDate).toLocaleDateString()} •{" "}
                                    {new Date(tx.TransDate).toLocaleTimeString()}
                                </div>

                            </div>
                        ))
                    )}

                </div>
            </div>

            <ConfirmPopup
                show={popup.show}
                message={popup.message}
                type={popup.type}
                onClose={handlePopupClose}
            />

        </div>
    );
};

export default History;